export const EMBEDDED_MAP = 'embedded-map';
